export default __webpack_public_path__ + "static/media/arrow-big-top.f0dfd020.svg";